<script lang="ts">
	import { getContext } from "svelte";
	import { Select } from "@xbs/svelte-wx";
	import { form } from "@xbs/lib-svelte";
	import type { IApi, ISearchOption } from "@xbs/lib-kanban";

	import Search from "../Search.svelte";

	const _ = getContext<any>("wx-i18n").getGroup("kanban");

	export let api: IApi;
	export let showOptions = true;
	export let options: ISearchOption[] = [
		{ id: null, label: _("Everywhere") },
		{ id: "label", label: _("Label") },
		{ id: "description", label: _("Description") },
	];

	$: cardsMeta = api && api.getReactiveState().cardsMeta;

	let searchResults = null;
	$: {
		if ($cardsMeta) {
			searchResults = Object.keys($cardsMeta).reduce((total, key) => {
				if ($cardsMeta[key].found) {
					total.push(api?.getCard(key));
				}
				return total;
			}, []);
			if (!searchResults.length) {
				searchResults = null;
			}
		}
	}

	const search = form({ value: "", by: options[0].id }, ({ value, by }) => {
		if (!by) by = null;
		const item = options.find(option => option.id === by);
		api.exec("set-search", {
			value,
			by,
			searchRule: item?.searchRule,
		});
	});

	let changeHandler: any;
	$: {
		if (!changeHandler) {
			changeHandler = (config: { value: string; by?: string }) => {
				if (
					config?.value !== $search.value ||
					config?.by !== $search?.by
				) {
					search.reset(config);
				}
			};
			api.on("set-search", changeHandler);
		}
	}

	function handleSearchAction({ detail }) {
		const { id, action } = detail;

		switch (action) {
			case "result-click":
				api.exec("select-card", { id });
				break;
			case "search-focus":
				if ($search.value) {
					api.exec("set-search", {
						value: $search.value,
						by: $search.by,
					});
				}
				break;
		}
	}

</script>

<Search
	bind:value={$search.value}
	{searchResults}
	on:action={handleSearchAction}>
	{#if showOptions}
		<div class="wx-select">
			<div class="wx-title">{_('Search in')}:</div>
			<Select bind:value={$search.by} {options} />
		</div>
	{/if}
</Search>

<style>
	.wx-title {
		display: block;
		padding-right: 2px;
		flex: 1 0 auto;
		font-family: var(--wx-label-font-family);
		font-size: var(--wx-label-font-size);
		line-height: var(--wx-label-line-height);
		font-weight: var(--wx-label-font-weight);
		color: var(--wx-label-font-color);
	}
	.wx-select {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		height: 36px;
		padding-left: 12px;
		padding-right: 8px;

		--wx-input-border: none;
	}

</style>
